import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { App } from '@capacitor/app';
import { Capacitor } from '@capacitor/core';
import { StatusBar, Style } from '@capacitor/status-bar';
import { CapacitorUpdater } from '@capgo/capacitor-updater';
import { AlertController, Platform } from '@ionic/angular';
import { register } from 'swiper/element/bundle';
import { FcmFirebaseProvider } from './provider/fcmFirebase.provider';
import { OneSignalProvider } from './provider/oneSignal.provider';
import { GoogleAnalyticsService } from './services/analitytics-service/google-analytics.service';
import { ModelLocatorService } from './services/config/model-locator.service';
import { OnboardService } from './services/config/onboard.service';
import { RemoteConfigService } from './services/config/remote-config.service';
import { MessageService } from './services/message-service/message.service';
import { UpdateAppOtaService } from './services/update/update-app.service';
register();

@Component({
    selector: 'app-root',
    templateUrl: 'app.component.html',
    styleUrls: ['app.component.scss'],
})
export class AppComponent {

    public url: string = '';
    public mostraMenu: string = '';
    pushes: any = [];
    appInfo: any = {
        build: '00001',
        id: 'br.com.icons4u.timepremiado',
        name: 'Time Multipremiado',
        version: '2025.02.03'
    };
    bundleVersion: string = '';

    /** Menu Principal */
    public menuPrincial = [
        {
            route: '/home',
            icon: { src: '../../assets/icon/icone_interacao.svg' },
            label: 'Interação',
            condition: 'interacao'
        },
        {
            route: '/store',
            icon: { name: 'gift-outline', class: 'icon-logout' },
            label: 'Loja',
            condition: 'premiacao'
        },
        // {
        //     route: '/benefits',
        //     icon: { src: '../../assets/icon/icone_beneficios.svg' },
        //     label: 'BENEFÍCIOS',
        //     condition: 'beneficios'
        // },
        {
            route: '/multi-awards',
            icon: { src: '../../assets/icon/icone_superacao.svg' },
            label: 'Multipremios',
            condition: 'multipremios'
        },
        {
            route: '/multiluck',
            icon: { src: '../../assets/icon/icone_multipremios.svg' },
            label: 'Multisorte',
            condition: 'multisorte'
        },
        {
            route: '/information',
            icon: { src: '../../assets/icon/icone_informacao.svg' },
            label: 'Informação',
            condition: 'informacao'
        },
        {
            route: '/faq',
            icon: { src: '../../assets/icon/icone_faq.svg' },
            label: 'Faq',
            condition: 'faq'
        },
        {
            route: '/my-points',
            icon: { src: '../../assets/icon/icone_pontos.svg', class: 'icon-logout' },
            label: 'Tabela de Pontos',
            condition: 'planos'
        },
        {
            route: '/help',
            icon: { src: '../../assets/icon/icone_suporte.svg' },
            label: 'Suporte',
            condition: 'suporte'
        }
    ];

    /** Menu Usuário */
    public menuUsuario = [
        {
            route: '/profile',
            icon: { src: '../../assets/icon/icone_perfil_quadrado.svg' },
            label: 'Meu Perfil',
            condition: 'perfil'
        },
        {
            route: '/activation-pre',
            icon: { src: '../../assets/icon/icone_ativacao.svg' },
            label: 'Registrar Vendas',
            condition: 'pre'
        },
        {
            route: '/activation-list',
            icon: { src: '../../assets/icon/icone_ativacao.svg' },
            label: 'Minhas Ativações',
            condition: 'ativacoes'
        },
        {
            route: '/quality',
            icon: { name: 'analytics', class: 'icon-logout' },
            label: 'Minha Qualidade',
            condition: 'qualidade'
        },
        {
            route: '/wallet',
            icon: { src: '../../assets/icon/icone_extrato.svg' },
            label: 'Minha Equipe',
            condition: 'carteira'
        },
        {
            route: '/extract',
            icon: { src: '../../assets/icon/icone_extrato.svg' },
            label: 'Meu Extrato',
            condition: 'extrato'
        },
        {
            route: '/my-rescue',
            icon: { name: 'gift', class: 'icon-logout' },
            label: 'Meus Resgates',
            condition: 'resgates'
        },
        {
            route: '/challenges',
            icon: { src: '../../assets/icon/icone_superacao.svg' },
            label: 'Meus Desafios',
            condition: 'desafios'
        },
        {
            route: '/my-categories',
            icon: { src: '../../assets/icon/icone_categoria.svg' },
            label: 'Minha Categoria',
            condition: 'categoria'
        },

        {
            route: '/ambassador',
            icon: { src: '../../assets/icon/icone_embaixador.svg' },
            label: 'Embaixador',
            condition: 'embaixador'
        },
        // {
        //     route: '/my-points',
        //     icon: { src: '../../assets/icon/icone_pontos.svg' },
        //     label: 'Meus Pontos',
        //     condition: 'categoria'
        // },
    ];


    constructor(
        public modelLocator: ModelLocatorService,
        public platform: Platform,
        private router: Router,
        private fcmFirebaseProvider: FcmFirebaseProvider,
        private oneSignalProvider: OneSignalProvider,
        private analytics: GoogleAnalyticsService,
        private alertController: AlertController,
        private messageService: MessageService,
        private onboardService: OnboardService,
        private remoteConfigService: RemoteConfigService,
        private updateAppOtaService: UpdateAppOtaService
    ) {
        this.initializeApp();
    }

    async initializeApp() {
        await this.platform.ready().then(async () => {
            // await this.androidService.checkPermissions();
            if (Capacitor.getPlatform() !== 'web') {
                StatusBar.setStyle({
                    style: Style.Light
                });
                StatusBar.setOverlaysWebView({ overlay: false });
                StatusBar.setBackgroundColor({ color: '#0b12ae' });
            }
            await this.fcmFirebaseProvider.getToken();
            await this.oneSignalProvider.setupPushOneSignal();
            await this.analytics.startAnalytics();
            await this.remoteConfigService.checkRemoteUpdateVersion();

            this.appInfo = await this.getInfoApp();

            await CapacitorUpdater.notifyAppReady();
            await this.updateAppOtaService.checkUpdate();
            this.bundleVersion = await this.updateAppOtaService.getCurrentBundleVersion();
        });
    }

    getPlatform() {
        return this.platform.is('android') || this.platform.is('ios');
    }

    /**
     * Gets condition
     * @author Starley Cazorla
     * @param menuItem
     * @returns true if condition
     */
    getCondition(menuItem: string): boolean {
        return this.modelLocator.menu[menuItem];
    }


    async touchLogout() {

        const alert = await this.alertController.create({
            header: 'Atenção!',
            message: 'Você deseja realmente sair?',
            mode: 'md',
            buttons: [
                {
                    text: 'Não',
                    role: 'cancel',
                    cssClass: 'secondary',
                    handler: () => {

                    }
                }, {
                    text: 'Sim',
                    handler: () => {
                        this.modelLocator.logado = false;
                        localStorage.clear();
                        this.modelLocator.urlretorno = '';
                        this.router.navigate(['/login']);
                    }
                }
            ]
        });

        await alert.present();
    }

    async getInfoApp() {
        if (this.platform.is('cordova')) return App.getInfo();

        let defaultConfig = {
            build: '00001',
            id: 'br.com.icons4u.timepremiado',
            name: 'Time Multipremiado',
            version: '2026.10.29',
        };

        return defaultConfig;
    }

    async touchPopUpChallenge(etapa: number) {
        if (etapa === 1) {
            this.modelLocator.popup_challenge_1 = false;
            this.modelLocator.popup_challenge_2 = true;
            this.router.navigate(['/challenges']);
        }

        if (etapa === 2) {
            this.modelLocator.popup_challenge_2 = false;
            this.modelLocator.popup_challenge_3 = true;
            this.router.navigate(['/challenges/list-of-challenges']);
        }

        if (etapa === 3) {
            this.modelLocator.popup_challenge_3 = false;
            this.modelLocator.popup_challenge_4 = true;
        }

        if (etapa === 4) {
            this.modelLocator.popup_challenge_4 = false;
            this.router.navigate(['/home']);
            await this.gravaNavegacaoDesafio();
        }
    }


    /**
     * Gravas navegacao desafio
     * @author Starley Cazorla
     */
    async gravaNavegacaoDesafio() {

        await this.onboardService.saveOnboardChallenge().then((data: any) => {
            if (data['status'] === 200) {
                this.modelLocator.dadosLogin.navegacao_desafio = true;
            } else {
                this.messageService.showToast('Erro ao gravar navegação. ' + data['message'], 'warning', 'bottom', 5000, true);
            }
        }).catch((error) => {
            this.messageService.showToast('Erro ao gravar navegação. ' + error['error'].message, 'warning', 'bottom', 5000, true);
        });
    }

    getBgColor(): string {

        let classificacao = this.modelLocator.dadosLogin.classificacao;

        switch (true) {
            case classificacao.includes('1'):
                return "#C40673"
            case classificacao.includes('2'):
                return "#FF4400"
            case classificacao.includes('3'):
                return "#B1892E"
            case classificacao.includes('4'):
                return "#273CFF"
            default:
                return "#C40673"
        }

    }

}
